module.exports = __webpack_public_path__ + "static/img/11.5bd134d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/12/sp/11.png
// module id = pSpe
// module chunks = 0